export const ROUTES = {
  HOME: "/skiply-portal/",
  FORGOT_PASSWORD: "/skiply-portal/ForgotPassword",
  MAIN_LANDING_PAGE: "/skiply-portal/MainLandingPage",
  LOGIN: "/skiply-portal/Login",
  SEARCH: "/skiply-portal/Search",
  REPORTS: "/skiply-portal/Reports",
  STUDENT_DATA: "/skiply-portal/StudentData",
  STUDENT_APP_CONFIG: "/skiply-portal/StudentAppConfig",
  USER_MANAGEMENT: "/skiply-portal/UserManagementGrid",
  NOTIFICATIONS: "/skiply-portal/Notifications",
  SMART_PLANS: "/skiply-portal/SmartPlans",
  SMART_PLANS_DETAIL: "/skiply-portal/SmartPlans/:planId",
  PAY_BY_LINK: "/skiply-portal/PayByLink",
  PAY_BY_LINK_DETAIL: "/skiply-portal/PayByLink/:ott",
  // PRICING: "/skiply-portal/Pricing",
  MERCHANT_OUTLET: "/skiply-portal",
  STUDENT_DATA_OUTLET: "StudentData",
  STUDENT_APP_CONFIG_OUTLET: "StudentAppConfig",
  USER_MANAGEMENT_OUTLET: "UserManagementGrid",
  NOTIFICATIONS_OUTLET: "Notifications",
  SMART_PLANS_OUTLET: "SmartPlans",
  SMART_PLANS_DETAIL_OUTLET: "SmartPlans/:planId",
  PAY_BY_LINK_OUTLET: "PayByLink",
  PAY_BY_LINK_DETAIL_OUTLET: "PayByLink/:ott",
  // PRICING_OUTLET: "Pricing",
  DIRECT_DEBIT: "/skiply-portal/DirectDebit",
  DIRECT_DEBIT_DETAIL: "/skiply-portal/DirectDebit/:mandateId",
  DIRECT_DEBIT_OUTLET: "DirectDebit",
  DIRECT_DEBIT_DETAIL_OUTLET: "DirectDebit/:mandateId",
  REMOVE: "/skiply-portal/profile/delete",
  MAIN_LANDING_OUTLET: "MainLandingPage",
  SEARCH_OUTLET: "Search",
  REPORTS_OUTLET: "Reports",
  MARKETPLACE: "/skiply-portal/Marketplace",
  MARKETPLACE_PRODUCTS: "/skiply-portal/Marketplace/:productId",
  MARKETPLACE_OUTLET: "Marketplace",
  CATEGORIES: "/skiply-portal/Marketplace/Categories",
  CATEGORY_DETAILS: "/skiply-portal/Marketplace/Categories/:categoryId",
  CATEGORY_DETAILS_OUTLET: "Marketplace/Categories/:categoryId",
  MARKETPLACE_DETAILS_OUTLET: 'Marketplace/:productId',
  TUTORIALS: "/skiply-portal/Tutorials",
};
